module.exports = __webpack_public_path__ + "569e52a8db80102d58207fc38ed6a974.pdf";